import React from 'react'
import RegisterGoogleSimple from '../common/GoogleOriginalDesign/Foodslabo/Simple/RegisterGoogleSimple'

export default function A8Affiliate() {
    return (
        <RegisterGoogleSimple
            reasonPoint1Images={[
                {
                    src: '/pages/a8/reason_point1_img1.png',
                    alt: 'A8の限定求人詳細1枚目',
                },
                {
                    src: '/pages/a8/reason_point1_img2.png',
                    alt: 'A8の限定求人詳細2枚目',
                },
                {
                    src: '/pages/a8/reason_point1_img3.png',
                    alt: 'A8の限定求人詳細3枚目',
                },
            ]}
            signupPath='signup?channel=a8'
        />
    )
}
